import script from "./home-card.vue?vue&type=script&setup=true&lang=js"
export * from "./home-card.vue?vue&type=script&setup=true&lang=js"

import "./home-card.vue?vue&type=style&index=0&id=79b9afc2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b9afc2"]])

export default __exports__